// src/data/shuttlesData.js - Contains all shuttle product data

export const shuttlesData = [
  {
    id: "hdi-shuttle",
    name: "HDI Shuttle",
    msrp: 240.00,
    image: "https://riversideoutdoors.ca/image/cache/catalog/HD12-500x500.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=HDI+Shuttle",
    description: "Professional-grade portable shuttle",
    notes: "Designed for optimal performance and durability"
  },
  // Add more shuttles as needed
]; 